module.exports = __webpack_public_path__ + "static/img/103895.ff48a780.png";